import { FC, SVGProps } from "react";

const LocationIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="currentcolor" {...props}>
      <path
        d="M8.75 0C3.925 0 0 3.925 0 8.75C0 13.868 4.69699 16.9699 7.80499 19.0229L8.334 19.374C8.46 19.458 8.605 19.5 8.75 19.5C8.895 19.5 9.04 19.458 9.166 19.374L9.69501 19.0229C12.803 16.9699 17.5 13.868 17.5 8.75C17.5 3.925 13.575 0 8.75 0ZM8.869 17.771L8.75 17.8501L8.631 17.771C5.621 15.783 1.5 13.061 1.5 8.75C1.5 4.752 4.752 1.5 8.75 1.5C12.748 1.5 16 4.752 16 8.75C16 13.061 11.878 15.784 8.869 17.771ZM8.75 5.5C6.958 5.5 5.5 6.958 5.5 8.75C5.5 10.542 6.958 12 8.75 12C10.542 12 12 10.542 12 8.75C12 6.958 10.542 5.5 8.75 5.5ZM8.75 10.5C7.785 10.5 7 9.715 7 8.75C7 7.785 7.785 7 8.75 7C9.715 7 10.5 7.785 10.5 8.75C10.5 9.715 9.715 10.5 8.75 10.5Z"
      />
    </svg>
  );
};

export default LocationIcon;
